import React from 'react';
import { useNavigate } from 'react-router-dom';
import SettingsLayout from '../../components/SettingsLayout';
import UsageMeter from '../../components/UsageMeter';
import { PlaceholderCard } from '../../components/PlaceholderCard';
import { CreditCard } from 'lucide-react';

const BillingPage = () => {
  const navigate = useNavigate();
  return (
    <SettingsLayout
      title="Billing"
      description="Manage your plan, invoices, and usage add-ons."
    >
      <div className="space-y-6">
        <UsageMeter variant="full" />

        <PlaceholderCard
          icon={CreditCard}
          title="Paid checkout is turning on soon"
          description="Payments go live once we've dogfooded Signal Sources for two more weeks. Until then, the demo tier is free and you can preview every paid feature."
          badge="Launching soon"
          primaryLabel="View pricing"
          onPrimary={() => navigate('/pricing')}
          testIdBase="billing"
          waitlistFeature="billing_launch"
        />
      </div>
    </SettingsLayout>
  );
};

export default BillingPage;
